import { CreateOrderPickupDTO } from "../../../../../models/order/order.request";

interface PersonalPickUpTabProps {
    orderPickupData: CreateOrderPickupDTO;
    onChange: (updatedData: CreateOrderPickupDTO) => void;
    pickUpAtError: string;
    totalAmount: number;
}

const PersonalPickUpTab: React.FC<PersonalPickUpTabProps> = ({ orderPickupData, onChange, pickUpAtError, totalAmount }) => {

    return (
        <div className="modal-form-div-group">
            <div className="modal-group-header">Detalji rezervacije</div>
            <div className="modal-form-div">
                <label className="modal-form-label">Datum i vreme preuzimanja *</label>
                <input className="form-input grey w-input" placeholder="Example Text" type="datetime-local"
                    value={orderPickupData.pickUpAt || ''}
                    onChange={(e) => onChange({ ...orderPickupData, pickUpAt: e.target.value })}
                />
                {pickUpAtError && <div className="error-text">{pickUpAtError}</div>}
            </div>
            <div className="modal-form-div">
                <label className="modal-form-label">Napomena</label>
                <textarea placeholder="Unesi napomenu (opciono)" className="form-textarea grey w-input"
                    value={orderPickupData.description || ''}
                    onChange={(e) => onChange({ ...orderPickupData, description: e.target.value })}    
                />
            </div>
            <div className="modal-form-div">
                <div className="input-div sb final-order-price">
                    <div>Ukupan iznos:</div>
                    <div className="text-block-38">{totalAmount} RSD</div>
                </div>
            </div>
        </div>
    );
};

export default PersonalPickUpTab;